export default __webpack_public_path__ + "static/whiteboard-brainstorming@2x-25997839d968c84a621a1d2df15958ea.webp";